import { ResponsiveVisibility, Skeleton, Text } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

export namespace PeriodLabelTypes {
  export interface Props {
    startDateNormalized?: string;
    endDateNormalized?: string;
    visibility?: ResponsiveVisibility;
    loading?: boolean;
  }
}
export const PeriodLabel: React.FC<PeriodLabelTypes.Props> = ({
  startDateNormalized,
  endDateNormalized,
  visibility = 'visible',
  loading,
}) => {
  const sanitizedVisibility: NonNullable<ResponsiveVisibility> = visibility ?? {};
  const currentVisibility = useBreakpointValue(
    typeof sanitizedVisibility === 'string' ? { base: sanitizedVisibility } : sanitizedVisibility
  );

  if (currentVisibility === 'hidden') {
    return null;
  }

  if (loading) {
    return <Skeleton height="inset.sm" width="110px" borderRadius="sm" />;
  }

  return <Text color="neutral.medium">{`${startDateNormalized} até ${endDateNormalized}`}</Text>;
};
